module.exports = __webpack_public_path__ + "static/media/whiteComment.a242e188.svg";